export default __webpack_public_path__ + "assets/download.83ce1f36.svg";